module.exports = __webpack_public_path__ + "static/media/visal-sm-logo.27e14794.JPG";